import Vue from 'vue'
import delayHydration from './hydration/hydrationRace.mjs'

import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from './components/nuxt-error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'

/* Plugins */

import nuxt_plugin_plugin_7d519023 from 'nuxt_plugin_plugin_7d519023' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_bootstrapvue_7862a630 from 'nuxt_plugin_bootstrapvue_7862a630' // Source: ./bootstrap-vue.js (mode: 'all')
import nuxt_plugin_gtm_3bcdf8cf from 'nuxt_plugin_gtm_3bcdf8cf' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_vuescrollto_2a4bfc30 from 'nuxt_plugin_vuescrollto_2a4bfc30' // Source: ./vue-scrollto.js (mode: 'client')
import nuxt_plugin_vuesweetalert2_14e5b3e0 from 'nuxt_plugin_vuesweetalert2_14e5b3e0' // Source: ./vue-sweetalert2.js (mode: 'client')
import nuxt_plugin_pluginutils_254b1fa2 from 'nuxt_plugin_pluginutils_254b1fa2' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_95fb6726 from 'nuxt_plugin_pluginrouting_95fb6726' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_c6a283bc from 'nuxt_plugin_pluginmain_c6a283bc' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_axios_3d6ed08e from 'nuxt_plugin_axios_3d6ed08e' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_trackingvariables_4a69e6c0 from 'nuxt_plugin_trackingvariables_4a69e6c0' // Source: ../../../plugins/tracking-variables.js (mode: 'client')
import nuxt_plugin_api_785206da from 'nuxt_plugin_api_785206da' // Source: ../../../plugins/api.js (mode: 'all')
import nuxt_plugin_directives_521c0486 from 'nuxt_plugin_directives_521c0486' // Source: ../../../plugins/directives.js (mode: 'client')
import nuxt_plugin_veevalidate_1a0c1998 from 'nuxt_plugin_veevalidate_1a0c1998' // Source: ../../../plugins/vee-validate.js (mode: 'client')
import nuxt_plugin_vuesplide_25ffda3f from 'nuxt_plugin_vuesplide_25ffda3f' // Source: ../../../plugins/vue-splide.js (mode: 'client')
import nuxt_plugin_bodyscrolllock_0af0c37e from 'nuxt_plugin_bodyscrolllock_0af0c37e' // Source: ../../../plugins/body-scroll-lock.js (mode: 'client')
import nuxt_plugin_reCaptcha_76d5e374 from 'nuxt_plugin_reCaptcha_76d5e374' // Source: ../../../plugins/reCaptcha.js (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

async function createApp(ssrContext, config = {}) {
if (typeof window !== 'undefined' && 'requestIdleCallback' in window) {
    await delayHydration()
}

  const router = await createRouter(ssrContext, config)

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Cursos de testing de software","titleTemplate":"%s | Abstracta Academy","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":"Aprende desde donde te encuentres, con los mejores instructores y a tu propio ritmo. Descubre nuestros cursos de testing de software."}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"https:\u002F\u002Fabstracta.academy\u002F\u002Ffavicon.ico"}],"script":[{"hid":"fb-pixel","innerHTML":"\n          !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window, document,'script','https:\u002F\u002Fconnect.facebook.net\u002Fen_US\u002Ffbevents.js');\n          fbq('init', '7972272349452894');\n          fbq('track', 'PageView');\n    \n          document.addEventListener('DOMContentLoaded', (event) =\u003E {\n            const price = sessionStorage.getItem('coursePriceUSD') || '100';\n            fbq('track', 'Purchase', {value: price, currency: 'USD'});\n          });\n        ","type":"text\u002Fjavascript","charset":"utf-8"},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);};w[y]('GTM-TLFQQJK')})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"__dangerouslyDisableSanitizers":["script"],"noscript":[{"innerHTML":"\u003Cimg height=\"1\" width=\"1\" style=\"display:none\" src=\"https:\u002F\u002Fwww.facebook.com\u002Ftr?id=7972272349452894&ev=PageView&noscript=1\"\u002F\u003E","body":true},{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-TLFQQJK&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"}],"style":[],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_7d519023 === 'function') {
    await nuxt_plugin_plugin_7d519023(app.context, inject)
  }

  if (typeof nuxt_plugin_bootstrapvue_7862a630 === 'function') {
    await nuxt_plugin_bootstrapvue_7862a630(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_3bcdf8cf === 'function') {
    await nuxt_plugin_gtm_3bcdf8cf(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuescrollto_2a4bfc30 === 'function') {
    await nuxt_plugin_vuescrollto_2a4bfc30(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuesweetalert2_14e5b3e0 === 'function') {
    await nuxt_plugin_vuesweetalert2_14e5b3e0(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_254b1fa2 === 'function') {
    await nuxt_plugin_pluginutils_254b1fa2(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_95fb6726 === 'function') {
    await nuxt_plugin_pluginrouting_95fb6726(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_c6a283bc === 'function') {
    await nuxt_plugin_pluginmain_c6a283bc(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_3d6ed08e === 'function') {
    await nuxt_plugin_axios_3d6ed08e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_trackingvariables_4a69e6c0 === 'function') {
    await nuxt_plugin_trackingvariables_4a69e6c0(app.context, inject)
  }

  if (typeof nuxt_plugin_api_785206da === 'function') {
    await nuxt_plugin_api_785206da(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_directives_521c0486 === 'function') {
    await nuxt_plugin_directives_521c0486(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_veevalidate_1a0c1998 === 'function') {
    await nuxt_plugin_veevalidate_1a0c1998(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuesplide_25ffda3f === 'function') {
    await nuxt_plugin_vuesplide_25ffda3f(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_bodyscrolllock_0af0c37e === 'function') {
    await nuxt_plugin_bodyscrolllock_0af0c37e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_reCaptcha_76d5e374 === 'function') {
    await nuxt_plugin_reCaptcha_76d5e374(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    app,
    router
  }
}

export { createApp, NuxtError }
